export default __webpack_public_path__ + "static/media/arrow-down.4c939266.svg";